import axios from "axios";

export default class ClubController {
    static async index() {
        const result = await axios.get<Club.Admin.Resources.Club[]>('/api/club/admin/clubs')
        return result.data
    }
}